<p-card class="!bg-[#f0f0f0]">
    <div class="flex flex-col h-full justify-between items-center max-w-80 min-h-96 p-4">
        <img alt="SisNot Logo" height="89" ngSrc="./assets/images/sisnot_logo.png" priority width="192"/>

        @if (loadingVisibility()) {
            <p-progress-spinner
                    ariaLabel="loading"
                    [style]="{
        '--p-progressspinner-color-one':  '#000',
    '--p-progressspinner-color-two':  '#E41B2E',
    '--p-progressspinner-color-three':'#000',
    '--p-progressspinner-color-four': '#E41B2E',
      width: '50px', height: '50px' }"
            />
        }

        <p class="text-sm text-black text-center">
            {{ message() }}
        </p>

        @if (buttonAcessarVisibility()) {
            <p-button
                    (onClick)="onAcessar()"
                    class="w-full"
                    styleClass="btn-gray">
                <app-icon-login/>
              Acessar
            </p-button>
        }

        @if (buttonVisitanteVisibility()) {
            <p-button
                    (onClick)="onVisitante()"
                    class="w-full"
                    [text]="true"
                    styleClass="btn-gray">
              Entrar como visitante
            </p-button>
        }
    </div>
</p-card>
